<template>
  <div>
    <div class="table-wrapper mt-6">
      <v-row class="table-controls items-center mb-1">
        <v-col sm="6" md="6" lg="6">
          <div>
            <v-btn
              color='transparent'
              depressed
              @click="createMapItem()"
              class='px-2'
            >
              <v-img max-height="14" max-width="14" class="mr-2" src="@/assets/icons/svg/plus.svg" />
              <span class="text-subtitle-2 font-weight-bold">Add Rack</span>
            </v-btn>
            <v-divider vertical class="mx-2 my-1" />
            <v-btn
              v-if="warehouse.map.racks.length > 0"
              color='transparent'
              depressed
              @click="printBarcodes()"
              class='px-2'
            >
              <v-img max-height="24" max-width="22" class="mr-2" src="@/assets/icons/svg/barcode-btn.svg" />
              <span class="text-subtitle-2 font-weight-bold">Download Barcode to Print</span>
            </v-btn>
          </div>
        </v-col>
        <v-col sm="6" md="6" lg="6">
          <div class="d-flex justify-end">
            <v-card flat class="items-center filter-select">
              <v-text-field
                v-model="search"
                placeholder="Search location"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle-outline"
                hide-details="auto"
                prepend-inner-icon="mdi-magnify"
              />
            </v-card>
          </div>
        </v-col>
      </v-row>
      <v-divider />
      <v-row class="table-controls mt-1 border-row">
        <v-col>
          <v-row>
            <v-col>
              <div class="th-title ml-2">Location Name</div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="table-data justify-space-between">
        <v-col cols="12" class="px-0 pt-0 pb-0">
          <v-row
            justify="space-between"
            v-if="warehouse.map.racks.length > 0"
          >
            <v-col cols="12">
              <v-treeview
                :items="items"
                :search="search"
                :filter="filter"
                class="map-treeview"
                hoverable
              >
                <template v-slot:append="{ item }">
                  <div class="d-flex justify-start">
                    <div class="flex flex-start align-center" style="width: 120px">
                      <div v-if="item.type == 'rack'">
                        <div>Type: <b>rack</b></div>
                      </div>
                      <div v-if="item.type == 'shelf'">
                        <div>Type: <b>shelf</b></div>
                      </div>
                      <div v-if="item.type == 'bin'">
                        <div>Type: <b>bin</b></div>
                      </div>
                    </div>
                    <div class="flex flex-start align-center" style="width: 200px">
                      <div v-if="item.type == 'rack'">
                        <div v-if="item.original.totalShelves">Number of shelves: <b>{{ item.original.totalShelves }}</b></div>
                      </div>
                      <div v-if="item.type == 'shelf'">
                        <div v-if="item.original.totalBins">Number of bins: <b>{{ item.original.totalBins }}</b></div>
                      </div>
                      <div v-if="item.type == 'bin'">
                        <div v-if="item.original.totalItems">Number of items: <b>{{ item.original.totalItems }}</b></div>
                      </div>
                    </div>
                    <div class="flex flex-start align-center" style="width: 130px">
                      <div class="px-1">
                        <v-btn
                          v-if="item.type == 'rack'"
                          color='transparent'
                          depressed
                          @click="createMapItem(item)"
                          class='px-2'
                        >
                          <v-img max-height="14" max-width="14" class="mr-2" src="@/assets/icons/svg/plus.svg" />
                          <span class="text-subtitle-2 font-weight-bold">Add Shelf</span>
                        </v-btn>
                        <v-btn
                          v-else-if="item.type == 'shelf'"
                          color='transparent'
                          depressed
                          @click="createMapItem(item)"
                          class='px-2'
                        >
                          <v-img max-height="14" max-width="14" class="mr-2" src="@/assets/icons/svg/plus.svg" />
                          <span class="text-subtitle-2 font-weight-bold">Add Bin</span>
                        </v-btn>
                      </div>
                    </div>
                    <div class="flex flex-start align-center px-1">
                      <img
                        class="mr-1 cursor-point"
                        style="height: 25px; width: 24px"
                        src="@/assets/icons/svg/barcode-btn.svg"
                        @click.stop="printBarcode(item)"
                        title="Download Barcode to Print"
                      />
                    </div>
                    <div class="flex flex-start align-center px-1">
                      <img
                        class="mr-1 cursor-point"
                        style="height: 16px; width: 16px"
                        src="@/assets/icons/svg/draw.svg"
                        @click.stop="itemToEdit = item"
                        title="Edit"
                      />
                    </div>
                    <div class="flex flex-start align-center px-1">
                      <img
                        style="height: 16px; width: 16px"
                        src="@/assets/icons/svg/delete1.svg"
                        class="cursor-point"
                        @click.stop="itemToDelete = item"
                        title="Delete"
                      />
                    </div>
                  </div>
                </template>
              </v-treeview>
            </v-col>
          </v-row>
          <div v-else>
            <div class="v-data-table__empty-wrapper">No data available</div>
          </div>
        </v-col>
      </v-row>
    </div>
    <WarehouseMapPopupDelete
      v-if='itemToDelete'
      :item='itemToDelete'
      :showPopup='!!itemToDelete'
      @delete="handleDeletePopup"
      @cancel='itemToDelete=null'
    />
    <WarehouseMapAddEditPopup
      v-if='itemToEdit'
      :items='items'
      :item='itemToEdit'
      :showPopup='!!itemToEdit'
      @save="handleAddEditPopup($event)"
      @cancel='itemToEdit = null'
    />
    <WarehouseMapBarcodeSettingsPopup
      v-if='showBarcodeSettings'
      :showPopup='showBarcodeSettings'
      :item='itemForDownloadBarcode'
      @save='downloadPDF($event)'
      @cancel='showBarcodeSettings = false'
    />
    <LoaderPopup :loader="loader" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import WarehouseMapAddEditPopup from '@/components/warehouses/popups/addEditWarehouseMap'
import WarehouseMapPopupDelete from '@/components/warehouses/popups/deleteWarehouseMap'
import LoaderPopup from '@/components/popup/loaderPopup'
import WarehouseMapBarcodeSettingsPopup from '@/components/warehouses/popups/setBarcodeSettings'
import service from '@/services/warehouses'
export default {
  name: 'WarehouseMap',
  components: {
    WarehouseMapAddEditPopup,
    WarehouseMapPopupDelete,
    WarehouseMapBarcodeSettingsPopup,
    LoaderPopup
  },
  props: {
    warehouse: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      items: [],
      itemToDelete: null,
      itemToEdit: null,
      search: null,
      caseSensitive: false,
      loader: false,
      showBarcodeSettings: false,
      itemForDownloadBarcode: null
    }
  },
  computed: {
    ...mapGetters('warehouses', ['getWarehousesList']),
    filter () {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined
    }
  },
  methods: {
    updateWarehouseMapTree() {
      this.getWarehousesList.forEach(w => {
        if (w.id === this.warehouse.id) {
          this.warehouse.map = w.map
        }
      })

      const map = []
      const createTreeNode = (id, label, type, original) => {
        return {
          id: id,
          name: label,
          type: type,
          barcode: original.barcode,
          original: original,
          children: []
        }
      }

      this.warehouse.map.racks.forEach(r => {
        const rack = createTreeNode(r.id, `${r.label}`, 'rack', r)
        r.shelves.forEach(sh => {
          const shelf = createTreeNode(sh.id, `${sh.label}`, 'shelf', sh)
          sh.bins.forEach(b => {
            const bin = createTreeNode(b.id, `${b.label}`, 'bin', b)
            shelf.children.push(bin)
          })
          rack.children.push(shelf)
        })
        map.push(rack)
      })

      this.items = map
    },
    createMapItem(parentItem) {
      const type = parentItem?.type === 'rack' ? 'shelf' : parentItem?.type === 'shelf' ? 'bin' : 'rack'
      this.itemToEdit = {
        id: 0,
        label: '',
        type: type,
        original: {
          label: ''
        }
      }
      if (parentItem?.type === 'rack') {
        this.itemToEdit.original.rackId = parentItem.original.id
        this.itemToEdit.color = ''
      } else if (parentItem?.type === 'shelf') {
        this.itemToEdit.original.rackId = parentItem.original.rackId
        this.itemToEdit.original.shelfId = parentItem.original.id
      }
    },
    preparePayload(item) {
      const payload = {
        warehouseId: this.warehouse.id
      }
      if (!item || !item.original) {
        return payload
      }
      if (item.original.id) {
        payload.id = item.original.id
      }
      if (item.original.rackId) {
        payload.warehouseRackId = item.original.rackId
      }
      if (item.original.shelfId) {
        payload.warehouseRackShelfId = item.original.shelfId
      }
      return payload
    },
    async doRequest(action, type, payload) {
      if (type === 'rack') {
        if (action === 'create') {
          return await service.createWarehouseRack(payload)
        } else if (action === 'update') {
          return await service.updateWarehouseRack(payload)
        } else if (action === 'delete') {
          return await service.deleteWarehouseRack(payload)
        }
      } else if (type === 'shelf') {
        if (action === 'create') {
          return await service.createWarehouseRackShelf(payload)
        } else if (action === 'update') {
          return await service.updateWarehouseRackShelf(payload)
        } else if (action === 'delete') {
          return await service.deleteWarehouseRackShelf(payload)
        }
      } else if (type === 'bin') {
        if (action === 'create') {
          return await service.createWarehouseRackShelfBin(payload)
        } else if (action === 'update') {
          return await service.updateWarehouseRackShelfBin(payload)
        } else if (action === 'delete') {
          return await service.deleteWarehouseRackShelfBin(payload)
        }
      } else {
        return false
      }
    },
    async handleDeletePopup() {
      const action = 'delete'
      const result = await this.doRequest(action, this.itemToDelete.type, this.preparePayload(this.itemToDelete))
      if (result?.data?.error?.type === 200) {
        await this.$store.dispatch('warehouses/loadWarehousesList')
        this.updateWarehouseMapTree()
      }
      this.itemToDelete = null
    },
    async handleAddEditPopup() {
      const action = this.itemToEdit.original.id ? 'update' : 'create'
      const payload = this.preparePayload(this.itemToEdit)
      payload.label = this.itemToEdit.original.label

      this.loader = true
      const result = await this.doRequest(action, this.itemToEdit.type, payload)
      if (result?.data?.error?.type === 200) {
        await this.$store.dispatch('warehouses/loadWarehousesList')
        this.updateWarehouseMapTree()
      }
      this.loader = false
      this.itemToEdit = null
    },
    async downloadPDF(settings) {
      const payload = {
        warehouseId: this.warehouse.id
      }
      if (settings) {
        payload.size = settings.size
      }

      const downloadFile = function(res) {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'warehouseMapBarcodes.pdf')
        document.body.appendChild(link)
        link.click()
      }

      this.showBarcodeSettings = false
      this.loader = true
      if (!this.itemForDownloadBarcode) {
        await service.getWarehouseMapBarcodesPdf(payload).then(downloadFile)
      } else {
        const item = this.itemForDownloadBarcode
        payload.warehouseRackId = item.type === 'rack' ? item.id : item.original.rackId
        payload.warehouseRackShelfId = item.type === 'shelf' ? item.id : item.original.shelfId
        payload.warehouseRackShelfBinId = item.type === 'bin' ? item.id : ''
        await service.getWarehouseMapItemBarcodePdf(payload).then(downloadFile)
        this.itemForDownloadBarcode = null
      }
      this.loader = false
    },
    async printBarcodes() {
      this.itemForDownloadBarcode = null
      this.showBarcodeSettings = true
    },
    async printBarcode(currentItem) {
      this.itemForDownloadBarcode = currentItem
      this.showBarcodeSettings = true
    }
  },
  created() {
    this.updateWarehouseMapTree()
  }
}
</script>

<style scoped lang="scss">
.table-wrapper {
  .table-controls.border-row {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);

    .th-title {
      font-size: 0.85rem;
      font-weight: bold;
      letter-spacing: 0.035rem;
      color: #43425d;
      white-space: nowrap;
    }
  }
  .table-data {
    background-color: #ffffff;
  }
  .v-data-table__empty-wrapper {
    color: rgba(0, 0, 0, 0.38);
    padding: 12px;
  }
}
</style>

<style lang="scss">
.v-treeview.map-treeview {
  > .v-treeview-node:last-child {
    border-bottom: 0;
  }

  .v-treeview-node__root {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }
}
</style>
